/**
 * @generated SignedSource<<73b0caf4ad3f6b78fefecc1cd62fb288>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersAppBarThemeArticle$data = {
  readonly articleTypes: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId: string;
    } | null> | null;
  } | null> | null;
  readonly sponsorType: string | null;
  readonly " $fragmentType": "helpersAppBarThemeArticle";
};
export type helpersAppBarThemeArticle$key = {
  readonly " $data"?: helpersAppBarThemeArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersAppBarThemeArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersAppBarThemeArticle"
};

(node as any).hash = "e3a30d98aa479209f172a26edfb593dd";

export default node;
